/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AssociatedCompanyFilterViewModel } from "../types/AssociatedCompanyFilterViewModel.ts";

export const associatedCompanyFilterViewModelSchema = z.object({
  cnpj: z.string().nullish(),
  name: z.string().nullish(),
  active: z.boolean().nullish(),
  poloId: z.number().int().nullish(),
  sortBy: z.string().default("name").nullish(),
  sortDirection: z.string().default("asc").nullish(),
  pageNumber: z.optional(z.number().int().default(1)),
  pageSize: z.optional(z.number().int().default(30)),
}) as unknown as ToZod<AssociatedCompanyFilterViewModel>;
